import { ref } from 'vue';
import { useStore } from 'vuex';
import { getLoginInfo, getLogout } from '../api/api';
import { UPDATE_LOGIN_ACCOUNT } from '../store/mutationType';
import { IS_FROM_SDK, SDK_PARAM } from '../utiles';

export default function () {
  const store = useStore();
  const userName = ref('');
  const initLoginInfo = async () => {
    // 判断是浏览器打开还是SDK内打开，SDK内打开直接从链接上拿，浏览器请求接口
    if (IS_FROM_SDK) {
      userName.value = SDK_PARAM.loginName || SDK_PARAM.loginAccount;
    } else {
      const res: any = await getLoginInfo();
      userName.value =
        res.result == 1 ? res.data.DISPLAY_NAME || res.data.LOGIN_ACCOUNT : '';
    }
    store.commit(UPDATE_LOGIN_ACCOUNT, userName.value);
  };
  const logout = async () => {
    await getLogout();
    userName.value = '';
    store.commit(UPDATE_LOGIN_ACCOUNT, '');
  };

  return {
    userName,
    initLoginInfo,
    logout
  }
}